<h4 *ngIf="data.titel" mat-dialog-title style="margin: 0px;">{{data.titel}}</h4>
<h4 *ngIf="!data.titel" mat-dialog-title style="margin: 0px;">Bitte wählen</h4>
<mat-dialog-content>
  <span>{{data.frage}}</span>

  <button mat-flat-button color="primary" *ngFor="let option of data.optionen; let i = index;"  [class.grey]="getGerade(i)" (click)="close(i)"
          style="margin-bottom: 10px; width: 100%">{{option.name || option}}
  </button>

</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button tabindex="-1" (click)="close(null)">Abbrechen</button>
</mat-dialog-actions>
